<template>
    <WtcFlag v-slot="{ targetUrl }" :flag-code="flagCode" :nat-code="natCode" :tag>
        <div class="flex items-center justify-start">
            <WtcImage
                v-if="targetUrl && !errorLoadingImage"
                class="h-[1em] max-w-min border border-black/10"
                :url="targetUrl"
                @error="errorLoadingImage = true"
            ></WtcImage>
            <span v-if="natCode" class="pl-1 text-[0.75em]">{{ natCode }}</span>
        </div>
    </WtcFlag>
</template>

<script setup lang="ts">
import { WtcFlag, WtcImage } from "@swisstiming/webtec-kit";
import { ref } from "vue";

defineProps({
    flagCode: String,
    natCode: String,
    tag: String
});

const errorLoadingImage = ref(false);
</script>
